import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { State } from "../../../../redux/slices";
import moment from "moment";

import {
  resetDecipherPassword,
  setEditingUser,
  setSelectedUser,
  setShowPassword,
  setUserValuesToEdit,
  initialState,
} from "../../../../redux/slices/userGroups/userGroupsSliceMultipleTables";

import { ThunkDispatch } from "@reduxjs/toolkit";
import { getUserRoleFromGroups } from "../../../../utils/auto-grouping";

import { SelectChangeEvent } from "@mui/material/Select";

import {
  getUserPassword,
  userUpdateValues,
} from "../../../../redux/actions/users/userAsyncActions";

import { selectLocale } from "../../../../redux/slices/layout";

import { userProfiles } from "../../../../redux/actions/users/managerAsyncActions/managerAsyncActions";
import UserActualInformation from "./userActualnformation";
import UserUpdateInformation from "./userInformationToUpdate";

export const style = {
  position: "absolute",
  top: "30%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  maxWidth: "calc(100% - 20px)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  maxWidth: "calc(100% - 20px)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  return {
    selectUser: () => {
      dispatch(setSelectedUser(null));
      dispatch(setEditingUser(false));
      dispatch(setUserValuesToEdit(initialState.userValuesUpdate));
    },
    setIsEditingUser: (userEditValues: any) => {
      dispatch(setEditingUser(true));
      dispatch(setUserValuesToEdit(userEditValues));
    },

    setUserEditValues: (values: any) => {
      dispatch(setUserValuesToEdit(values));
    },

    updateUser: (token: string, userId: string) => {
      dispatch(userUpdateValues({ token, userId }));
    },

    fetchRoles: (token: string) => {
      dispatch(userProfiles(token));
    },
    resetPassword: () => {
      dispatch(resetDecipherPassword());
    },
    setShowPassword: (value: boolean) => {
      dispatch(setShowPassword(value));
    },
    getPassword: (token: string, userId: string) => {
      dispatch(getUserPassword({ token, userId }));
    },
  };
};

export const DetailUserView = () => {
  const {
    selectUser,
    setIsEditingUser,
    setUserEditValues,
    updateUser,
    fetchRoles,
    resetPassword,
    setShowPassword,
    getPassword,
  } = SetActions();
  const {
    selectedUser,
    isEditingUser,
    userValuesUpdate,
    isUpdateLoading,
    isUpdateError,
    loadingUserPassword,
    decipherPassword,
    showPassword,
  } = useSelector((state: State) => state.CreateTablesUsersReducer);

  const { userRoles } = useSelector(
    (state: State) => state.CreateManagersReducer,
  );
  const groups = selectedUser?.rawGroups;
  const memberships = selectedUser?.groupMemberships;

  const { locations } = useSelector((state: State) => state.LocationsReducer);
  const locale = useSelector(selectLocale);
  const { actions } = useSelector((state: State) => state.MasterInfoReducer);
  const { user } = useSelector((state: State) => state.Authentication);

  const token = user?.token ?? "";

  const createdAt = moment(selectedUser?.createdAt);
  createdAt.locale(locale);
  const createdAtModify = createdAt.format("l, LT");

  const handleClickShowPassword = async () => {
    if (showPassword) {
      setShowPassword(false);
    } else if (selectedUser) {
      getPassword(token, selectedUser.id);
    }
  };

  useEffect(() => {
    return () => {
      // clean password when unmounting component
      resetPassword();
    };
  }, []);

  const selectLocalePhoneDefaultInfo = () => {
    switch (locale) {
      case "fr":
        return { code: "FR", label: "France", phone: "33", suggested: true };
      case "en":
        return {
          code: "US",
          label: "United States",
          phone: "1",
          suggested: true,
        };
      case "es":
        return {
          code: "MX",
          label: "Mexico",
          phone: "52",
          suggested: true,
        };
      case "de":
        return {
          code: "DE",
          label: "Germany",
          phone: "49",
          suggested: true,
        };
      default:
        return {
          code: "US",
          label: "United States",
          phone: "1",
          suggested: true,
        };
    }
  };

  const selectLocalePhoneDefaultCode = () => {
    switch (locale) {
      case "fr":
        return "+33";
      case "en":
        return "+1";
      case "es":
        return "+52";
      case "de":
        return "+49";
      default:
        return "+1";
    }
  };

  useEffect(() => {
    fetchRoles(token);
  }, []);

  // Update user

  const handleLocationChange = (event: SelectChangeEvent) => {
    setUserEditValues({
      ...userValuesUpdate,
      site: event.target.value as string,
    });
  };

  return (
    <Box sx={style2}>
      {!isEditingUser ? (
        <UserActualInformation
          selectedUser={selectedUser}
          createdAtModify={createdAtModify}
          getUserRoleFromGroups={getUserRoleFromGroups}
          memberships={memberships}
          groups={groups}
          userRoles={userRoles}
          locale={locale}
          showPassword={showPassword}
          decipherPassword={decipherPassword}
          loadingUserPassword={loadingUserPassword}
          handleClickShowPassword={handleClickShowPassword}
          selectUser={selectUser}
          setShowPassword={setShowPassword}
          setIsEditingUser={setIsEditingUser}
          userValuesUpdate={userValuesUpdate}
          selectLocalePhoneDefaultInfo={selectLocalePhoneDefaultInfo}
          selectLocalePhoneDefaultCode={selectLocalePhoneDefaultCode}
        />
      ) : (
        <UserUpdateInformation
          actions={actions}
          locale={locale}
          isUpdateLoading={isUpdateLoading}
          userValuesUpdate={userValuesUpdate}
          selectedUser={selectedUser}
          isUpdateError={isUpdateError}
          locations={locations}
          handleLocationChange={handleLocationChange}
          updateUser={updateUser}
          setShowPassword={setShowPassword}
          selectUser={selectUser}
          token={token}
          setUserEditValues={setUserEditValues}
        />
      )}
    </Box>
  );
};
